import { Button, cn, ICON_COLOR } from '@zep-us/zus';
import { XIcon } from '@zep-us/zus/icons';
import { useAiBuilderChatCopy } from '../hooks/useAiBuilderChatCopy';
import { AiBuilderAttachmentExtensionIcon } from './AiBuilderAttachmentExtensionIcon';
type AiBuilderFileChipProps = {
  fileName: string;
  extension?: string;
  /** 없으면 표시 전용(메시지 첨부, 39062:30589), 있으면 X 포함 제거 가능(컴포저 툴바, 37421:22804) */
  onRemove?: () => void;
  disabled?: boolean;
  className?: string;
};

/**
 * 첨부 파일 칩 — 확장자 아이콘 + 파일명(+ X).
 * 제거 가능일 때는 AiBuilderSelectedQuizContextChip과 동일하게 칩 전체 클릭이 제거 동작이다.
 */
export const AiBuilderFileChip = ({
  fileName,
  extension,
  onRemove,
  disabled = false,
  className
}: AiBuilderFileChipProps) => {
  const copy = useAiBuilderChatCopy();
  const extensionIcon = <AiBuilderAttachmentExtensionIcon extension={extension} className="size-4 flex-none" />;
  if (!onRemove) {
    return <span
    // ZUS Button outlined/neutral/sm 표면과 동일 토큰 — 인터랙션 없는 표시 전용이라 span
    className={cn('flex h-[36px] w-fit min-w-0 max-w-full items-center gap-3xs rounded-[8px] border border-opacity px-sm text-body-sm-semibold text-gray-700', className)}>
        {extensionIcon}
        <span className="min-w-0 truncate">{fileName}</span>
      </span>;
  }
  return <Button type="button" variant="outlined" intent="neutral" size="sm" rounded="default" className={cn('max-w-full overflow-hidden', className)} aria-label={copy.fileChip.removeAriaLabel} disabled={disabled} leftSlot={extensionIcon} rightSlot={<XIcon size="xs" fill={ICON_COLOR.neutral} aria-hidden="true" />} onClick={onRemove} data-sentry-element="Button" data-sentry-component="AiBuilderFileChip" data-sentry-source-file="AiBuilderFileChip.tsx">
      <span className="min-w-0 truncate">{fileName}</span>
    </Button>;
};